import { LiveSttFragment } from '@ftr/contracts/regional-api'
import { generateUuid, Uuid } from '@ftr/contracts/type/shared'
import { RealTimeSttSegmentMap } from '../../../types'
import { TransactionResult } from './operation-result'
import { bumpStartTimeEditsToProduceUniqueTime } from './unique-start-time-utils'

export interface SplitRemarkOperation {
  // e.g. enter pressed in the middle of a remark
  type: 'splitRemark'
  remarkId: Uuid
  updateFragments: LiveSttFragment[]
  newRemarkFragments: LiveSttFragment[]
}

export function splitRemarkOperationTransaction(
  operation: SplitRemarkOperation,
  segmentMap: RealTimeSttSegmentMap,
): TransactionResult {
  // Find the remark in the segment map
  const remark = segmentMap.findRemark(operation.remarkId)
  if (!remark) {
    throw new Error(`Remark with ID ${operation.remarkId} not found in segment map`)
  }

  const newUtteranceId = generateUuid()
  const uniqueStartTimeEdits = bumpStartTimeEditsToProduceUniqueTime(
    operation.newRemarkFragments[0].startTime,
    segmentMap,
    'forward',
  )
  return {
    type: 'transaction',
    transaction: {
      id: generateUuid(),
      edits: [
        ...uniqueStartTimeEdits,
        {
          type: 'upsertUtterance',
          utteranceId: operation.remarkId,
          fragments: operation.updateFragments,
          dialect: remark.dialect ?? null,
          speakerId: remark.speakerId,
        },
        {
          type: 'upsertUtterance',
          utteranceId: newUtteranceId,
          dialect: remark.dialect ?? null,
          speakerId: remark.speakerId,
          fragments: operation.newRemarkFragments,
        },
      ],
    },
    sideEffects: [
      {
        type: 'focusRemark',
        remarkId: newUtteranceId,
        selectionIndex: 0,
      },
    ],
  }
}
